import { render } from "./MsComboboxMultipleV2.vue?vue&type=template&id=13090572&scoped=true"
import script from "./MsComboboxMultipleV2.vue?vue&type=script&lang=js"
export * from "./MsComboboxMultipleV2.vue?vue&type=script&lang=js"

import "./MsComboboxMultipleV2.vue?vue&type=style&index=0&id=13090572&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13090572"]])

export default __exports__